@let vm = vm$();

<div class="ui-tab w-100 h-100 flex-col gap-16">
  @if (vm.viewState !== 'INITIAL_LOADING' && vm.viewState !== 'INITIAL_EMPTY') {
    <div class="flex-row space-between-center">
      <ui-search
        style="width: 320px"
        [searchQuery]="vm.search"
        (onInput)="search.set($event)"
        [placeholder]="'COMMON.SEARCH' | translate"
      ></ui-search>

      <ui-button
        [text]="'COMMON.CREATE' | translate"
        (click)="create()"
      ></ui-button>
    </div>
  }

  <div class="h-100 min-h-0">
    <div class="h-100 min-h-0 flex-col">
      @switch (vm.viewState) {
        @case ('INITIAL_LOADING') {
          <div class="flex-row center-center w-100 h-100">
            <ui-preloader
              [color]="loaderColor.blue"
            ></ui-preloader>
          </div>
        }
        @case ('INITIAL_EMPTY') {
          <div class="flex-row flex center-center w-100 h-100">
            <ui-no-data 
              [imgSrc]="noData.imgSrc"
              [title]="noData.title | translate"
              [createButtonText]="noData.createButtonText | translate"
              (onCreate)="create()"
            ></ui-no-data>
          </div>
        }
        @case ('NO_RESULTS') {
          <div class="flex-row flex center-center w-100 h-100">
            <ui-no-data 
              [imgSrc]="noResults.imgSrc" 
              [title]="noResults.title | translate"
            ></ui-no-data>
          </div>
        }
        @case ('HAS_DATA') {
          <ui-dataset-table
            [data]="vm.filteredContacts"
            [config]="tableConfig()"
            (rowAction)="onRowAction($event)"
          ></ui-dataset-table>
        }
      }
    </div>
  </div>
</div>
